import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class InnerCommunicationDataPassService {

  private childModalClose = new BehaviorSubject<boolean>(false);
  childModalClose$ = this.childModalClose.asObservable();

  constructor() { }

  childModalCloseEvent(value: boolean = true) {
    this.childModalClose.next(value);
  }
}
